const isInIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
if (isInIframe()) {
    console.log('Inbox is running inside an iframe');
    // 1. Patch HTMLElement.prototype.focus to prevent scroll
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (options) {
        // Force preventScroll: true when in iframe
        const newOptions = Object.assign(Object.assign({}, options), { preventScroll: true });
        originalFocus.call(this, newOptions);
    };
    // 2. Patch Element.prototype.scrollIntoView to scroll ONLY internal containers
    Element.prototype.scrollIntoView = function (arg) {
        let element = this;
        if (!element.offsetParent)
            return;
        // Logic: Walk up the tree, finding scrollable ancestors, and scrolling them manually.
        // Stop when we reach document/body to avoid scrolling the window/parent.
        let current = element.parentElement;
        while (current) {
            // Stop if we reached the top of the iframe document
            if (current === document.body || current === document.documentElement) {
                break;
            }
            const style = window.getComputedStyle(current);
            const overflowY = style.overflowY;
            const isScrollable = overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
            if (isScrollable) {
                const container = current;
                const elementRect = element.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                // Logic: if element is outside container, scroll container.
                // We align to bottom by default as that's common for chat.
                const isBelow = elementRect.bottom > containerRect.bottom;
                const isAbove = elementRect.top < containerRect.top;
                if (isBelow) {
                    // Scroll down
                    container.scrollTop += (elementRect.bottom - containerRect.bottom);
                }
                else if (isAbove) {
                    // Scroll up
                    container.scrollTop -= (containerRect.top - elementRect.top);
                }
                // If visible, do nothing.
            }
            current = current.parentElement;
        }
    };
    // 3. Block window.scrollTo / window.scroll to prevent global page jumps
    // Many libs use window.scrollTo(0,0) on route change or focus.
    const noopScroll = () => { };
    window.scrollTo = noopScroll;
    window.scroll = noopScroll;
    // Note: We DO NOT block Element.prototype.scrollTo or scrollBy, 
    // because LazyLoadList uses them for internal scrolling, which is safe.
}
